<template>
  <div class="education-list-item">
    <div class="title" @click="getMore(itemData.id)">
      <span
        class="title-text"
        :style="{'maxWidth':'600px'}"
      >{{itemData.title}}</span>
      <span class="title-time">{{itemData.add_time | parseTime('{y}-{m}-{d}')}}</span>
    </div>
    <div
      class="detail"
      :style="{'maxWidth':$route.name =='announceList'?1040+'px':740+'px'}"
    >{{itemData.desc}}</div>
    <div class="more" @click="getMore(itemData.id)">详情 ></div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["itemData"],
  methods: {
    getMore(id) {
      if (this.itemData.link != ""&&this.itemData.link) {
        window.open(this.itemData.link);
      } else {
        this.$emit("toPage", id);
      }
    }
  }
};
</script>

<style scoped>
.education-list-item {
  border-bottom: 1px solid #e6ecf2;
  padding: 25px 0;
  box-sizing: border-box;
  position: relative;
}
.education-list-item:last-child {
  border-bottom: none;
}
.education-list-item .more {
  position: absolute;
  top: 26px;
  right: 0;
  font-size: 14px;
  color: #194eb0;
  width: 60px;
  text-align: center;
  height: 40px;
  cursor: pointer;
}
.education-list-item .title {
  color: #194eb0;
  font-size: 0;
  margin-bottom: 10px;
  padding-right: 60px;
  box-sizing: border-box;
  cursor: pointer;
}
.education-list-item .title .title-text {
  max-width: 600px;
  font-size: 20px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: middle;
}
.title:hover .title-text {
  text-decoration: underline;
}
.education-list-item .title .title-time {
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
}
.education-list-item .detail {
  color: #222222;
  font-size: 16px;
  line-height: 30px;
  max-width: 740px;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>




// WEBPACK FOOTER //
// src/components/views/common/listItem.vue